/// <reference path="../../typings/tsd.d.ts" /> 

module warsApp.services {

    export class ApplicationCodeService {
        private logType: string = "ApplicationCodeService";

        private url = './api/Code/GetCodes';

        private delay = 200;
        private holdingForServiceCall = false;
        private applicationCodesToQuery: models.ApplicationCodePromise[];
        private applicationCodesBeingQueried: models.ApplicationCodePromise[];


        constructor(
            private $http: ng.IHttpService,
            private $q: angular.IQService,
            private $timeout: angular.ITimeoutService,
            private manageSystemCodeService: services.ManageSystemCodesService)
        {
            this.applicationCodesToQuery = [];
            this.applicationCodesBeingQueried = [];
        }

        public getApplicationCodesForEnum(enumerationName: string): angular.IPromise<models.ApplicationCode[]> {
            var model = new models.GetCodeModel();
            model.enumName = enumerationName;
            model.isEnum = true;

            return this.registerGetExecutionCodesCall(model);
        }

        public getProcessLevelApplicationCodesForExecution(codeGroupId: string, processConfigId: string, includeInactiveCodes?: boolean): angular.IPromise<models.ApplicationCode[]>
        {
            var model = new models.GetCodeModel();
            model.codeGroupId = codeGroupId;
            model.processConfigId = processConfigId;
            model.isEnum = false;
            services.WarsLogger.logDebug("Getting Process Level Application Codes for Code: " + codeGroupId + ", Process Config ID: " + processConfigId, this.logType);

            return this.registerGetExecutionCodesCall(model, includeInactiveCodes);
        }

        public getSystemLevelApplicationCodesForExecution(codeGroupId: string, includeInactiveCodes?: boolean): angular.IPromise<models.ApplicationCode[]> {
            var model = new models.GetCodeModel();
            model.codeGroupId = codeGroupId;
            model.isEnum = false;

            return this.registerGetExecutionCodesCall(model, includeInactiveCodes);
        }

        public getApplicationCodesForConfiguration(codeGroupId: string, includeInactiveCodes?: boolean): angular.IPromise<models.ApplicationCode[]> {
            var d = this.$q.defer();

            this.manageSystemCodeService.getCodeGroup(codeGroupId).then(
                (configCodeGroup) => {
                    var codeGroup = new models.CodeGroup();
                    codeGroup.groupName = configCodeGroup.id;
                    codeGroup.codes = [];

                    for (var i = 0; i < configCodeGroup.codes.length; i++) {
                        var currentCode = configCodeGroup.codes[i];
                        if (!includeInactiveCodes && !currentCode.isActive) continue;
                        var applicationCode = new models.ApplicationCode(
                            currentCode.uniqueIdentifier,
                            currentCode.parentCodeGroup_id,
                            currentCode.shortDescription,
                            currentCode.longDescription,
                            currentCode.isActive);
                        codeGroup.codes.push(applicationCode);
                    }
                    d.resolve(codeGroup.codes);
                });

            return d.promise;
        }

        private registerGetExecutionCodesCall(model: models.GetCodeModel, includeInactiveCodes?: boolean):  angular.IPromise<models.ApplicationCode[]> {
            var d = this.$q.defer();

            if (includeInactiveCodes === undefined) includeInactiveCodes = false;

            if (!this.holdingForServiceCall) {
                this.holdingForServiceCall = true;
                this.$timeout(() => this.makeServiceCall(), this.delay);
            }

            var match = Enumerable.from(this.applicationCodesToQuery).singleOrDefault(i => i.model.equals(model) && i.includeInactiveCodes === includeInactiveCodes);
            if (match) return match.deferred.promise;

            this.applicationCodesToQuery.push(new models.ApplicationCodePromise(model, includeInactiveCodes, d));
            return d.promise;
        }

        private makeServiceCall(): void {
            var self = this;
            this.applicationCodesBeingQueried = angular.copy(this.applicationCodesToQuery);
            this.applicationCodesToQuery = [];
            this.holdingForServiceCall = false;

            var codesAlreadyCached = Enumerable.from(this.applicationCodesBeingQueried).select(i => i.model).where(c => c.getName() != null && this.codeGroupCache[c.getName()]).distinct().toArray(); 
            var getCodeModels = Enumerable.from(this.applicationCodesBeingQueried).select(i => i.model).where(c => c.getName() == null || !this.codeGroupCache[c.getName()]).distinct().toArray();

            var codeIdAndEnumNames = Enumerable.from(getCodeModels).select(i => i.getName()).toArray();

            services.WarsLogger.logInfo("Querying for the following application codes: " + codeIdAndEnumNames, this.logType);

            if (!getCodeModels || getCodeModels.length === 0) {
                self.processServiceCallResponse([], codesAlreadyCached);
            } else {
                this.$http.post(this.url, { codesToRetrieve: getCodeModels })
                    .then((result: any) => self.processServiceCallResponse(result.data, codesAlreadyCached));
            }
        }   

        private codeGroupCache:any = {};

        private processServiceCallResponse(codeGroups: models.CodeGroup[],codesCached:models.GetCodeModel[]) {

            for (var index = 0; index < this.applicationCodesBeingQueried.length; index++) {

                var currentCodeGroup = this.applicationCodesBeingQueried[index].model.getName();
                var includeInactiveCodes = this.applicationCodesBeingQueried[index].includeInactiveCodes;

                var matchingCodeGroup = Enumerable.from(codeGroups).firstOrDefault(i => i.groupName === currentCodeGroup);
                var matchingCachedCodeGroup = Enumerable.from(codesCached).firstOrDefault(i => i.getName()=== currentCodeGroup);;
                if (matchingCachedCodeGroup) {
                    this.applicationCodesBeingQueried[index].deferred.resolve(this.codeGroupCache[currentCodeGroup]);
                    continue;
                }
                else if (!matchingCodeGroup) {
                    this.applicationCodesBeingQueried[index].deferred.resolve([]);
                    return;
                }
                var matchingCodesInCodeGroup = matchingCodeGroup.codes;

                if (!includeInactiveCodes) {
                    matchingCodesInCodeGroup = Enumerable.from(matchingCodesInCodeGroup).where(i => i.isActive).toArray();
                }

                if (matchingCodesInCodeGroup === undefined || matchingCodesInCodeGroup === null || matchingCodesInCodeGroup.length === 0) {
                    this.applicationCodesBeingQueried[index].deferred.reject();
                } else {
                    services.WarsLogger.logInfo(matchingCodesInCodeGroup.length + " Application codes returned from server for code group: " + currentCodeGroup, this.logType);
                    if (this.applicationCodesBeingQueried[index].model.codeGroupId){
                        this.codeGroupCache[currentCodeGroup] = matchingCodesInCodeGroup;
                    }
                    this.applicationCodesBeingQueried[index].deferred.resolve(matchingCodesInCodeGroup);
                }
            }
        }

        public buildCodeDropDownOptions(
            codes: models.ApplicationCode[],
            maintainOrder: boolean,
            context?: models.CodeDropDownContext,
            defaultOption?: models.CodeDropDownItem): models.CodeDropDownItem[]
        {
            if (context) {
                if (context.removeSpecifiedOptions) {
                    codes = Enumerable.from(codes).where(i => context.removeSpecifiedOptions.indexOf(i.uniqueIdentifier) === -1).toArray();
                }
                if (context.includeSpecifiedOptionsOnly) {
                    codes = Enumerable.from(codes).where(i => context.includeSpecifiedOptionsOnly.indexOf(i.uniqueIdentifier) !== -1).toArray();
                }
            }

            var dropDownItems = new Array<models.CodeDropDownItem>();
            if (defaultOption) dropDownItems.push(defaultOption);
            var options = Enumerable.from(codes).select(i => new models.CodeDropDownItem(i.shortDescription, i.uniqueIdentifier)).toArray();

            if (!maintainOrder) {
                options = Enumerable.from(options).orderBy(i => i.text).toArray();
            }

            dropDownItems = dropDownItems.concat(options);
            return dropDownItems;
        }

        buildEnumDropDownOptions(
            codes: models.ApplicationCode[],
            maintainOrder: boolean,
            context?: models.EnumDropDownContext,
            defaultOption?: models.EnumDropDownItem): models.EnumDropDownItem[]
        {
            if (context) {
                if (context.removeSpecifiedOptions) {
                    codes = Enumerable.from(codes).where(i => context.removeSpecifiedOptions.indexOf(parseInt(i.uniqueIdentifier)) === -1).toArray();
                }
                if (context.includeSpecifiedOptionsOnly) {
                    codes = Enumerable.from(codes).where(i => context.includeSpecifiedOptionsOnly.indexOf(parseInt(i.uniqueIdentifier)) !== -1).toArray();
                }
            }

            var dropDownItems = new Array<models.EnumDropDownItem>();
            if (defaultOption) dropDownItems.push(defaultOption);
            var options = Enumerable.from(codes).select(i => new models.EnumDropDownItem(i.shortDescription, parseInt(i.uniqueIdentifier))).toArray();

            if (!maintainOrder) {
                options = Enumerable.from(options).orderBy(i => i.text).toArray();
            }

            dropDownItems = dropDownItems.concat(options);
            return dropDownItems;
        }
    }
}

warsApp.registerService('ApplicationCodeService', ['$http', '$q', '$timeout', "manageSystemCodesService"]);